import Link from 'next/link';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center space-x-2 text-sm" aria-label="Breadcrumb">
      <Link
        href="/home-page"
        className="text-body-text hover:text-brand-purple transition-colors flex items-center"
      >
        <HomeIcon className="w-4 h-4" />
        <span className="sr-only">Home</span>
      </Link>
      {items.map((item, index) => (
        <div key={index} className="flex items-center space-x-2">
          <ChevronRightIcon className="w-4 h-4 text-gray-400" />
          {item.href && index !== items.length - 1 ? (
            <Link
              href={item.href}
              className="text-body-text hover:text-brand-purple transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-navy-dark font-medium">{item.label}</span>
          )}
        </div>
      ))}
    </nav>
  );
}